import * as React from 'react';
import styled from 'styled-components';

const QuoteItemContainer = styled.div`
  width: 100%;
  display: flex;
  height: 90%;
  flex-direction: column;
  background: #fafafa;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 40px;
  padding-bottom: 24px;
  margin-bottom: 30px;
`;

const QuoteText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;

  color: rgba(0, 20, 77, 0.6);

  margin-bottom: 70px !important;
`;

const PersonNameText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: normal;

  color: #00144d;

  margin-left: 16px;
  margin-bottom: 0px !important;
`;

const PersonDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  position: absolute;
  left: 40px;
  bottom: 50px;
`;

const QuoteImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 20px;
`;

interface QuoteItemProps {
  quoteText: string;
  quoteImg: string;
  quoteName: string;
}

const QuoteItem = ({ quoteImg, quoteName, quoteText }: QuoteItemProps) => {
  return (
    <QuoteItemContainer>
      <QuoteText>"{quoteText}"</QuoteText>
      <PersonDetailsContainer>
        <QuoteImage src={quoteImg} />
        <PersonNameText>{quoteName}</PersonNameText>
      </PersonDetailsContainer>
    </QuoteItemContainer>
  );
};

export default QuoteItem;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/components/QuoteItem.tsx